import { FormState } from "final-form";
import React from "react";
import { FieldInputProps, FieldMetaState, FormSpy } from "react-final-form";
import { useSelector } from "react-redux";

import { FormField, Input, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { selectAgents } from "store/entities/agents";
import { selectTeams } from "store/entities/teams";
import { withVar } from "themes/helpers";

import { guessRuleName } from "./input";
import { IRuleForm } from "./types";

type IProps = {
  input: FieldInputProps<string, HTMLInputElement>;
  meta: FieldMetaState<string>;
};

export const NameInput: React.FC<IProps> = ({ input, meta }) => {
  const agents = useSelector(selectAgents);
  const teams = useSelector(selectTeams);
  const updateWorkflowName = (formData: FormState<IRuleForm>): void => {
    if (formData?.active === "name" || formData?.values?.name !== "") return;
    const guessedName = guessRuleName(formData?.values, agents, teams);
    if (guessedName !== null && !formData?.touched?.name) {
      input.onChange(guessedName);
    }
  };

  return (
    <Flex column maxWidth="640px" marginTop={withVar(SpacingToken.Spacing4)}>
      <FormField labelText="Name" error={meta.touched && meta.error}>
        <Input
          data-testid="workflow-name-input"
          {...input}
          placeholder="Enter name..."
          value={input.value}
          onChange={event => input.onChange(event.target.value)}
          data-1p-ignore
          autoComplete="off"
          error={meta.error && meta.touched}
        />
      </FormField>
      <FormSpy
        subscription={{ values: true, errors: true, touched: true, active: true }}
        onChange={updateWorkflowName}
      />
    </Flex>
  );
};
